export const enum ControlTabs {
  STYLE = 'style',
  DIMENSIONS = 'dimensions',
  CANOPY = 'canopy',
  BEAMS = 'beams',
  SUMMARY = 'summary'
}
